export default __webpack_public_path__ + "static/media/pexels-suzy-hazelwood-1629236.6a2e0976.jpg";